import { PageCanvas, PageHeader } from "@/components/page-canvas";
import { LanguageChoice } from "@/components/language-choice";
import { CompanySwitcher } from "@/components/company-switcher";
import { Head, usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import {
  OnboardingForm,
  type OnboardingProps,
} from "@/components/onboarding/onboarding-form";
export default function Onboarding(props: OnboardingProps) {
  const { t } = useTranslation();
  const { auth } = usePage().props;
  return (
    <PageCanvas as="main" className="min-h-svh">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <CompanySwitcher />
        <LanguageChoice />
      </div>
      <Head title={t("onboarding.title")} />
      <PageHeader
        title={t("onboarding.title")}
        description={t("access.setup_help")}
      />
      <OnboardingForm key={`${auth.account?.id}:${auth.user?.id}`} {...props} />
    </PageCanvas>
  );
}
